<template>
  <div class="fields">
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input" @click="focusRef" :class="hasValue">
      <input type="email"
             :class="{inputClass, noIcons: !haveIcon}"
             ref="input"
             autocomplete="off"
             readonly="readonly"
             :placeholder="placeholderAsProp"
             v-model="content"
             v-on:input="updateValue($event.target.value)"
             v-on:keydown="handleKeyDown"
             v-on:keypress="handleKeyPress"
             v-on:click="handleClick"
             v-on:mousedown="handleMouseDown"
             v-on:mouseup="handleMouseUp"
      />
    </div>
  </div>
</template>

<script>
  import baseInput from './mixins/input.class';
  import {initializable} from "./mixins/input.mixin";
  import {checkEmail} from "../helpers/field-checker.helper";
  import {F_ERR_ENUM} from "../enum/field-error.enum";

  export default {
    extends: baseInput,
    mixins: [initializable],
    name: "email-input",
    props: {
      haveIcon: {
        type: Boolean,
        default: false
      },
      useMailChecker: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleMouseDown () {
        this.$refs.input.focus();
      },
      handleMouseUp () {
        this.$refs.input.blur();
        this.$refs.input.removeAttribute('readonly');
      },
      computeErrors() {
        if (this.useMailChecker) {
          if (!checkEmail(this.content.trim())) {
            this.setError(F_ERR_ENUM.INCORRECT, this.$t('email-input.invalidFormat'));
            return;
          }
          this.setError(F_ERR_ENUM.INCORRECT, null);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/email-input.vue